import { CartType, UserInfoType } from "../../services/restAPI/endpoints/User/UserTypes";

type ActionTypes =
   | { type: "SET_USER_INFO"; payload: UserInfoType }
   | { type: "SET_USER_ID"; payload: string }
   | { type: "SET_DEPARTMENTS" }
   | { type: "SET_USER_SESSION_DATA"; payload: { platform: string; token: string } }
   | { type: "SET_USER_CURRENT_LOCATION"; payload: string }
   | { type: "SET_AVATAR_LINK"; payload: string }
   | { type: "CLEAR_USER" }
   | { type: "SET_MAIN_PAGE"; payload: string }
   | { type: "SET_USER_CART"; payload: CartType }
   | { type: "CHANGE_USER_CART_ID"; payload: { shopId: string; cartId: string } };

const INIT_STATE: UserInfoType = {
   id: null,
   oldId: null,
   mainPageUrl: "",
   firstName: "",
   lastName: "",
   email: "",
   login: "",
   roles: [],
   companies: [],
   phoneNumber: "",
   activated: false,
   langKey: null,
   timeZone: null,
   avatarUrl: null,
   avatarLink: null,
   loggedFrom: null,
   legacyName: "",
   legacyHost: "",
   legacyApiController: "",
   legacyScope: "",
   platform: "",
   platformToken: "",
   currentLocation: null,
   isLoggedFirstTime: false,
   firstLoginRedirectUrl: null,
   sideBarTabs: [],
   carts: [],
   chosenMailbox: {},
   departments: [],
   currentDepartmentId: null,
   nonAcceptedConsents: [],
   sharedAccounts: [],
   sharedAccountsWithStatus: [],
};

const userReducer = (state = INIT_STATE, action: ActionTypes): UserInfoType => {
   switch (action.type) {
      case "SET_DEPARTMENTS": {
         return {
            ...state,
            departments: [],
         };
      }
      case "SET_MAIN_PAGE": {
         return {
            ...state,
            mainPageUrl: action.payload,
         };
      }
      case "SET_USER_ID": {
         return {
            ...state,
            id: +action.payload,
         };
      }
      case "SET_AVATAR_LINK": {
         return {
            ...state,
            avatarLink: action.payload,
         };
      }
      case "CLEAR_USER": {
         return INIT_STATE;
      }
      case "SET_USER_SESSION_DATA": {
         return {
            ...state,
            platform: action.payload.platform,
            platformToken: action.payload.token,
         };
      }
      case "SET_USER_CURRENT_LOCATION": {
         return {
            ...state,
            currentLocation: action.payload,
         };
      }
      case "SET_USER_INFO": {
         return {
            ...state,
            id: action.payload.id,
            oldId: action.payload.oldId,
            mainPageUrl:
               action.payload.mainPageUrl === "/messages/new"
                  ? "/cases/new"
                  : action.payload.mainPageUrl,
            firstName: action.payload.firstName,
            lastName: action.payload.lastName,
            email: action.payload.email,
            login: action.payload.login,
            roles: action.payload.roles,
            companies: action.payload.companies,
            phoneNumber: action.payload.phoneNumber,
            activated: action.payload.activated,
            langKey: action.payload.langKey,
            timeZone: action.payload.timeZone,
            avatarUrl: action.payload.avatarUrl,
            loggedFrom: action.payload.loggedFrom,
            legacyName: action.payload.legacyName,
            legacyHost: action.payload.legacyHost,
            legacyApiController: action.payload.legacyApiController,
            legacyScope: action.payload.legacyScope,
            isLoggedFirstTime: action.payload.isLoggedFirstTime,
            firstLoginRedirectUrl: action.payload.firstLoginRedirectUrl,
            sideBarTabs: action.payload.sideBarTabs,
            carts: action.payload.carts,
            nonAcceptedConsents: action.payload.nonAcceptedConsents,
            sharedAccounts: action?.payload?.sharedAccounts,
            sharedAccountsWithStatus: action?.payload?.sharedAccountsWithStatus,
            departments: action?.payload?.departments,
            currentDepartmentId: action?.payload?.currentDepartmentId ?? null,
         };
      }
      case "SET_USER_CART": {
         const shopId = action.payload.shopId;
         const cartExists = () => {
            if (state?.carts?.length) {
               return state.carts.some((cart) => cart.shopId === shopId);
            }
            return false;
         };

         if (cartExists())
            return {
               ...state,
            };
         return {
            ...state,
            carts: [...state.carts, action.payload],
         };
      }
      case "CHANGE_USER_CART_ID": {
         const shopId = action.payload.shopId;
         const cartId = action.payload.cartId;

         const cartExists = () => {
            if (!!state?.carts?.length) {
               return state.carts.some((cart) => cart.shopId === shopId);
            }
            return false;
         };

         if (cartExists()) {
            const currentCarts = state.carts;

            const changedCarts = currentCarts.map((cart) => {
               if (cart.shopId === shopId) {
                  cart.id = cartId;
                  return cart;
               } else {
                  return cart;
               }
            });
            return {
               ...state,
               carts: changedCarts,
            };
         }
         return { ...state };
      }

      default:
         return state;
   }
};

export default userReducer;
